import axios from "@/plugins/axios";

export default class Service {
  static api = axios;
}
